module.exports = __webpack_public_path__ + "static/media/phonepe-logo.10e3b159.svg";